

import navIconMap from './navIconMaps';
import burnIconMaps from './burnIconMaps';
import burnSeverityIconMaps from './burnSeverityIconMaps';
import sexGenderIconMaps from './sexGenderIconMaps';
import filterIconMaps from './filterIconMaps';
import canvasIconMap from './canvasIconMap';
import communicationIconMaps from './communicationIconMaps';
import deviceIconMap from './deviceIconMap';
import crudIconMaps from './crudIconMaps';
import timeIconMaps from './timeIconMaps';
import genericIconMaps from './genericIconMaps';
import healthIconMaps from './healthIconMaps';
import notificationIconMaps from './notificationIconMaps';
import bodySiteImageIconMaps from './bodySiteImageIconMaps';
import resourceIconMaps from './resourceIconMaps';
import marketingIconMaps from './marketingIconMaps';
import richTextIconMaps from './richTextIconMaps';
import videoEditIconMaps from './videoEditIconMaps';

export default {
	...burnIconMaps,
	...burnSeverityIconMaps,
	...canvasIconMap,
	...communicationIconMaps,
	...crudIconMaps,
	...deviceIconMap,
	...filterIconMaps,
	...genericIconMaps,
	...navIconMap,
	...sexGenderIconMaps,
	...timeIconMaps,
	...healthIconMaps,
	...notificationIconMaps,
	...bodySiteImageIconMaps,
	...resourceIconMaps,
	...marketingIconMaps,
	...richTextIconMaps,
	...videoEditIconMaps,
};